import { FC } from 'react'
import { SvgProps } from './svgProps'

const HeartIcon: FC<SvgProps> = ({ width, height, color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || 17}
    height={height || 17}
    viewBox="0 0 17 17"
  >
    <use href="#heart-icon-definition" stroke={color || '#595959'} />
  </svg>
)

export default HeartIcon
